import { type BeltColor } from '~/domain/shared/models/belt-color';

// type names got a little criss-crossed here, but by name we mean White/Gray/Yellow/etc
// and by color, we mean the hex color that corresponds to that belt name
export const beltNamesToColors: Record<BeltColor, string> = {
  White: '#FFFFFF',
  Grey: '#BDBDBD',
  Yellow: '#F8C50F',
  Orange: '#EF6C00',
  Green: '#64DD17',
  Blue: '#2962FF',
  Purple: '#6200EA',
  Brown: '#957609',
  Black: '#212121',
  Coral: '#FF5252',
  Red: '#E53935',
};
